module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp2_7016.506aa769.png";